export default __webpack_public_path__ + "static/media/gallery_21.eb695d65.jpg";